module.exports = __webpack_public_path__ + "frontend/images/agents/phone-57477ac70e8c0066e706a204a51920f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/phone.jpg
// module id = 350
// module chunks = 2